import { PropsWithChildren } from "react";
import {
  BackButton,
  Heading,
  Responsive,
  Skeleton,
  skeletonize,
} from "@songtradr-one/components-frontend";
import { Flex } from "../flex/Flex.Parts";
import { Header, Props, TabbedPageContainer } from "./TabbedShell.Parts";

const SkeletonHeading = skeletonize(Heading);
const SkeletonBackButton = skeletonize(BackButton);

export const TabbedShellSkeleton = ({
  className,
  pageTitle,
  back,
  children,
}: Partial<Props> & PropsWithChildren) => (
  <TabbedPageContainer className={className}>
    <Header>
      {back && <SkeletonBackButton />}
      <Flex $align="center" $justify="space-between">
        <Responsive
          mobile={
            <SkeletonHeading variant="h2" tag="h1">
              {pageTitle}
            </SkeletonHeading>
          }
          desktop={<SkeletonHeading variant="h1">{pageTitle}</SkeletonHeading>}
        />
      </Flex>
    </Header>
    <Skeleton $height="2.5rem" $width="10.25rem" />
    {children}
  </TabbedPageContainer>
);
